export default __webpack_public_path__ + "static/media/logo.773379e9.png";